import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { KEY_DOWN_COMMAND, COMMAND_PRIORITY_LOW } from 'lexical';
import { useEffect } from 'react';
import { SHOW_LINK_EDITOR_COMMAND } from '../FloatingLinkEditorPlugin';

export function KeyboardShortcutPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        KEY_DOWN_COMMAND,
        (event) => {
          const e = event as KeyboardEvent;
          const isCmd = e.metaKey || e.ctrlKey;
          if (!isCmd) return false;
          if (e.key.toLowerCase() !== 'k') return false;
          e.preventDefault();
          editor.dispatchCommand(SHOW_LINK_EDITOR_COMMAND, undefined);
          return true;
        },
        COMMAND_PRIORITY_LOW,
      ),
    [editor],
  );

  return null;
}
